// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LogoOrcom_wrapper__2lVku","svg":"LogoOrcom_svg__1B1sp"};